import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { MeioPagamentoTributario } from "../api/dto/meio-pagamento-tributario";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class MeioPagamentoTributarioService {
    constructor(private http: HttpClient) {}

    private url: string = UrlServidor.URL_BASE + "meios-pagamentos-tributarios";

    listarAplicaveis(): Observable<MeioPagamentoTributario[]> {
        return this.http.get<MeioPagamentoTributario[]>(this.url + "/aplicaveis");
    }
}
